import axios from 'axios'
import { DateTime } from 'luxon'
import { RangeDetails } from '#components'

export default {
  methods: {
    loadRanges() {
      return new Promise(async (resolve, reject) => {
        let response
        try {
          response = await axios.get(this.baseDomain + this.shopId + '/resources/' + this.resource.id + '/ranges.json?apikey=' + this.apiKey)
        } catch(e) {
          this.ranges = []
          reject(e)
          return
        }
        this.ranges = response.data
        resolve(response.data)
      })
    },
    addRange() {
      this.editRange({ id: 'new-' + new Date().getTime(), mode: 'allow', weekdays: '1,2,3,4,5,6,7', timestart: 0, timeend: 1440 })
    },
    editRange(range) {
      this.showModal('rangedetails', RangeDetails, {
        props: {
          selectedRange: range
        },
        events: {
          save: this.saveRange,
          remove: this.deleteRange
        },
        handlers: {},
        width: 900
      })
    },
    saveRange(range) {
      const index = this.ranges.findIndex(r => r.id === range.id)
      if (index !== -1) {
        this.ranges[index] = range
      } else {
        const order = ['allow', 'denyswitch', 'deny']
        this.ranges.push(range)
        this.ranges = this.ranges.sort((a, b) => order.indexOf(a.mode) > order.indexOf(b.mode) ? 1 : -1)
      }
    },
    deleteRange(range) {
      this.ranges = this.ranges.filter(r => r.id !== range.id)
    },
    convertToTime(minutes) {
      let minStr = (minutes % 60)
      if (minStr < 10) {
        minStr = '0' + minStr
      }
      return Math.floor(minutes / 60) + '.' + minStr
    },
    makeDayRangeStr(dayNumbers) {
      const _ = this._
      const allDays = [_('mo'), _('tu'), _('we'), _('th'), _('fr'), _('sa'), _('su')]
      let rangeStr = this.getRangeStr(allDays, dayNumbers)
      return new String(rangeStr).toLowerCase()
    },
    getRangeStr(allElements, selectedNumbers) {
      let rangeStr = ''
      for (let i in selectedNumbers) {
        const n = parseInt(i, 10) - 1
        let already = false
        if (!selectedNumbers[n]) {
          rangeStr += allElements[n]
          already = true
        }
        if (!selectedNumbers[parseInt(i, 10) + 1]) {
          if (already) {
            rangeStr += ', '
          } else {
            rangeStr += '-' + allElements[n] + ', '
          }
        }
      }
      if (rangeStr.length) {
        rangeStr = rangeStr.substring(0, rangeStr.length - 2)
      }
      return rangeStr
    },
    makeRangeDesc(range) {
      const _ = this._
      let desc = '<i class="fa fa-fw fa-check-circle"></i> '
      if (range.ext_id) {
        desc += '<i class="fa fa-fw fa-google"></i> '
      }
      desc += _('Allowed') + ' '
      if (range.mode === 'deny') {
        desc = '<i class="fa fa-fw fa-ban"></i> '
        if (range.ext_id) {
          desc += '<i class="fa fa-fw fa-google"></i> '
        }
        desc += _('Prevented') + ' '
      } else if (range.mode === 'denyswitch') {
        desc = '<i class="fa fa-fw fa-ban"></i> '
        if (range.ext_id) {
          desc += '<i class="fa fa-fw fa-google"></i> '
        }
        desc += _('Starting and ending prevented') + ' '
      }
      let hasModifiers = false
      if (range.dateend || range.datestart) {
        desc += (range.datestart ? DateTime.fromFormat(range.datestart, 'd.M.yyyy').toFormat(this.dateFormat) : '') + ' - ' + (range.dateend ? DateTime.fromFormat(range.dateend, 'd.M.yyyy').toFormat(this.dateFormat) : '') + '; '
        hasModifiers = true
      }
      let weekdays = range.weekdays.split(',')
      if(weekdays.length !== 7) {
        let dayNumbers = []
        for (let i = 0; i < weekdays.length; i++) {
          dayNumbers[weekdays[i]] = true
        }
        desc += this.makeDayRangeStr(dayNumbers) + ' '
        hasModifiers = true
      }
      if (parseInt(range.timestart, 10) !== 0 || parseInt(range.timeend) !== 1440) {
        desc += _('from') + ' ' + DateTime.fromFormat(this.convertToTime(range.timestart), 'H.mm').toFormat(this.timeFormat) + ' ' + _('to') + ' ' + DateTime.fromFormat(this.convertToTime(range.timeend), 'H.mm').toFormat(this.timeFormat)
        hasModifiers = true
      }
      if (!hasModifiers) {
        desc += _('always')
      }
      desc = desc.replace(/[ ,;]+$/, '')
      return desc
    }    
  }
}